import { api } from './client';
import type {
  AuthResponse,
  LoginRequest,
  RegisterRequest,
  RegisterResponse,
  User,
  InvitationInfo,
} from './types';

export const authApi = {
  login: (req: LoginRequest) => api.post<AuthResponse>('/auth/login', req),
  register: (req: RegisterRequest) => api.post<RegisterResponse>('/auth/register', req),
  me: () => api.get<User>('/auth/me'),
  changePassword: (req: { currentPassword: string; newPassword: string }) =>
    api.post<void>('/auth/change-password', req),
  requestPasswordReset: (email: string) =>
    api.post<void>('/auth/forgot-password', { email }),
  resetPassword: (token: string, newPassword: string) =>
    api.post<void>('/auth/reset-password', { token, newPassword }),
  verifyEmail: (token: string) => api.post<void>('/auth/verify-email', { token }),
  resendVerification: (email: string) => api.post<void>('/auth/resend-verification', { email }),
  invitationInfo: (code: string) => api.get<InvitationInfo>(`/invitations/${encodeURIComponent(code)}`),
  acceptInvitation: (code: string) => api.post<void>(`/invitations/${encodeURIComponent(code)}/accept`),
};
